/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { matrixDependencies } from './dependenciesMatrix.generated';
import { createResize } from '../../factoriesAny.js';
export var resizeDependencies = {
  matrixDependencies: matrixDependencies,
  createResize: createResize
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesResize.generated.js
// module id = 1632
// module chunks = 0